import React, { FC, useEffect } from "react";
import * as NavigationActions from '../../../actions/navigation';
import RestrictedLayout from "../../../components/layouts/RestrictedLayout";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { ProjectSettingsBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { SettingsProjectsSubMenu, SettingsSubMenu } from "../../../helpers/subMenuHelper";
import useDispatch, { useActionCreator } from "../../../hooks/useDispatch";
import useSelector from "../../../hooks/useSelector";
import SettingsCard from "../SettingsCard";

import './ProjectSettingsPage.scss';

const ProjectSettings: FC = () => {
    // Sidebar items
    const permissions = useSelector(state => state.user.userSummary?.permissions ?? []);
    const sideBarItems = SettingsSubMenu(permissions);
    
    // Breadcrumbs
    const breadcrumbs = ProjectSettingsBreadcrumbs();

    // Menu items
    const menuItems = SettingsProjectsSubMenu(permissions);

    const dispatch = useDispatch();
    const setDrawerItems = useActionCreator(NavigationActions.SetDrawerItems, dispatch);
    const setBreadcrumbs = useActionCreator(NavigationActions.SetBreadcrumbs, dispatch);

    useEffect(() => {
        setDrawerItems(sideBarItems);
        setBreadcrumbs(breadcrumbs);
    }, [setDrawerItems, setBreadcrumbs]);

    const renderProjectSettingsCards = () => {
        return menuItems?.filter(x => x.description)?.map((item, index) => (
            <SettingsCard 
                key={`item-${item.title}-${index}`}
                navItem={item}
            />
        ));
    }

    return (
        <RestrictedLayout
            permission={Dtos.Permission.ProjectSettingsView}
        >
            <div className="settings-page">
                <div className="settings-container">
                    <h1 className="mb-4">Project</h1>
                    <div className="settings-grid">
                        {renderProjectSettingsCards()}
                    </div>
                </div>
            </div>
        </RestrictedLayout>
    );
}

export default ProjectSettings;